import { BufOrStr } from '../types';
import { isBuf, isStr } from '../utils/common';
import { StringBufAggsHisto, UTF8_STATUS } from './getHistoAndBasicAggs.types';
import { utf8d } from './utf8d';

function _getHistoAndBasicAggs(b: BufOrStr, aggs?: StringBufAggsHisto): StringBufAggsHisto {
	const { histo, nulls } = (aggs = aggs || {
		utf8State: UTF8_STATUS.ACCEPT,
		validUtf8: true,
		allAscii: true,
		nulls: [0, 0, 0, 0],
		numNulls: 0,
		histo: new Array(256).fill(0),
		length: 0,
		numInvalidUtf8Seqs: 0,
		numValidUtf8Seqs: 0,
	});

	let utf8State = aggs.utf8State;

	const len = b.length;
	let i = 0;
	if (isStr(b)) {
		for (; i < len; ++i) {
			const byte = b.charCodeAt(i);
			++histo[byte];

			if (byte === 0) {
				const idx = (aggs.length + i) % 4;
				nulls[idx]++;
			}

			// We don't care about the codepoint, so this is
			// a simplified version of the decode function.
			const type = utf8d[byte];
			const newUtf8State = utf8d[256 + utf8State * 16 + type];

			if (newUtf8State === UTF8_STATUS.REJECT) {
				++aggs.numInvalidUtf8Seqs;

				// Reset state
				utf8State = UTF8_STATUS.ACCEPT;
			} else {
				if (utf8State !== UTF8_STATUS.ACCEPT && newUtf8State === UTF8_STATUS.ACCEPT) {
					++aggs.numValidUtf8Seqs;
				}
				utf8State = newUtf8State;
			}

			if (aggs.allAscii && byte > 0x7f) {
				aggs.allAscii = false;
			}
		}
	} else {
		for (; i < len; ++i) {
			const byte = b[i];
			++histo[byte];

			if (byte === 0) {
				const idx = (aggs.length + i) % 4;
				nulls[idx]++;
			}

			// We don't care about the codepoint, so this is
			// a simplified version of the decode function.
			const type = utf8d[byte];
			const newUtf8State = utf8d[256 + utf8State * 16 + type];

			if (newUtf8State === UTF8_STATUS.REJECT) {
				++aggs.numInvalidUtf8Seqs;

				// Reset state
				utf8State = UTF8_STATUS.ACCEPT;
			} else {
				if (utf8State !== UTF8_STATUS.ACCEPT && newUtf8State === UTF8_STATUS.ACCEPT) {
					++aggs.numValidUtf8Seqs;
				}
				utf8State = newUtf8State;
			}

			if (aggs.allAscii && byte > 0x7f) {
				aggs.allAscii = false;
			}
		}
	}

	aggs.utf8State = utf8State;
	aggs.validUtf8 = aggs.numInvalidUtf8Seqs === 0 && utf8State === UTF8_STATUS.ACCEPT;
	aggs.numNulls = aggs.nulls[0] + aggs.nulls[1] + aggs.nulls[2] + aggs.nulls[3];

	aggs.length += b.length;

	return aggs;
}

export function getHistoAndBasicAggs(
	strbufs: BufOrStr | BufOrStr[],
	aggs?: StringBufAggsHisto
): StringBufAggsHisto {
	aggs = aggs ?? {
		utf8State: UTF8_STATUS.ACCEPT,
		validUtf8: true,
		allAscii: true,
		nulls: [0, 0, 0, 0],
		numNulls: 0,
		histo: new Array(256).fill(0),
		length: 0,
		numInvalidUtf8Seqs: 0,
		numValidUtf8Seqs: 0,
	};

	if (isStr(strbufs) || isBuf(strbufs)) {
		aggs = _getHistoAndBasicAggs(strbufs, aggs);
	} else {
		for (const strbuf of strbufs) {
			aggs = _getHistoAndBasicAggs(strbuf, aggs);
		}
	}

	return aggs;
}
